import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./JobTemplates.scss";

const JobTemplates = () => {
  // Définition du titre de la page
  UseTitle("Liste des métiers");

  const { isAdmin } = useAuth();

  const [listJobTemplates, setListJobTemplates] = useState([]);
  const [listInfos, setListInfos] = useState([]);

  const [isInitialLoading, setIsInitialLoading] = useState(true);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const [search, setSearch] = useState("");
  const [searchNatal, setSearchNatal] = useState();
  const [ordering, setOrdering] = useState("name");
  const [pageSize, setPageSize] = useState(12);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();

  const handlePageChange = (newPage) => setPage(newPage);

  useEffect(() => {
    const fetchJobTemplates = async () => {
      if (listJobTemplates.length === 0) setIsInitialLoading(true);
      else setIsRefreshing(true);

      try {
        const response = await api.get(
          `/jobtemplate/?search=${search}&is_natal=${searchNatal}&ordering=${ordering}&page_size=${pageSize}&page=${page}`
        );
        setListJobTemplates(response.data.results);
        setListInfos(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsInitialLoading(false);
        setIsRefreshing(false);
      }
    };

    fetchJobTemplates();
  }, [search, searchNatal, ordering, page, pageSize]);

  return (
    <div className="job-templates list-page">
      <div className="title">
        <h1>Liste des métiers</h1>
        {isAdmin && (
          <button className="bt" onClick={() => navigate("/job/new")}>
            Ajouter un métier
          </button>
        )}
      </div>

      {/* Filtres */}
      <div className="filters">
        <div>
          <label htmlFor="search">Rechercher </label>
          <input
            type="text"
            id="search"
            name="search"
            value={search}
            onChange={(event) => (setSearch(event.target.value), setPage(1))}
          />
        </div>
        <div>
          <label htmlFor="ordering">Trier par </label>
          <select
            id="ordering"
            name="ordering"
            value={ordering}
            onChange={(event) => setOrdering(event.target.value)}
          >
            <option value="name">Ascendant</option>
            <option value="-name">Descendant</option>
          </select>
        </div>
        <div>
          <label htmlFor="is_natal">Région de départ </label>
          <select
            id="is_natal"
            name="is_natal"
            value={searchNatal}
            onChange={(event) => (
              setSearchNatal(event.target.value), setPage(1)
            )}
          >
            <option value="">All</option>
            <option value={true}>Oui</option>
            <option value={false}>Non</option>
          </select>
        </div>
        <div>
          <label htmlFor="pagesize">Nombre d'affichage </label>
          <select
            id="pagesize"
            name="pagesize"
            value={pageSize}
            onChange={(event) => (setPageSize(event.target.value), setPage(1))}
          >
            <option value="6">6</option>
            <option value="12">12</option>
            <option value="24">24</option>
            <option value="48">48</option>
          </select>
        </div>

        {listJobTemplates.length != 0 && <h2>Métiers ({listInfos.count})</h2>}
      </div>

      {/* Chargment Initial */}
      {isInitialLoading && (
        <div className="loading-data">
          <div className="loading-spinner"></div>
          <div className="loading-text">Chargement...</div>
        </div>
      )}

      {/* Chargment des métiers */}
      {!isInitialLoading &&
        (listJobTemplates.length === 0 ? (
          <div className="no-data">
            <p>
              <strong>Aucun métier trouvé</strong>
            </p>
          </div>
        ) : (
          <div className={`list-div ${isRefreshing ? "loading" : ""}`}>
            {listJobTemplates.map((jobTemplate) => (
              <NavLink
                key={jobTemplate.id}
                className="list-card"
                to={`/job/${jobTemplate.id}`}
              >
                <h4>{jobTemplate.name}</h4>

                {/* Affichage des skills */}
                {jobTemplate.skills_templates.length > 0 && (
                  <div className="skills">
                    <h5>Compétences ({jobTemplate.skills_templates.length})</h5>
                    <ul>
                      {jobTemplate.skills_templates.map(
                        (skills_templates, index) => (
                          <li key={index} className="skill">
                            {skills_templates.name}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}

                {/* Affichage des sorts */}
                {jobTemplate.spells_templates.length > 0 && (
                  <div className="spells">
                    <h5>Sorts ({jobTemplate.spells_templates.length})</h5>
                    <ul>
                      {jobTemplate.spells_templates.map(
                        (spells_templates, index) => (
                          <li key={index} className="spell">
                            {spells_templates.name}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </NavLink>
            ))}
          </div>
        ))}

      {/* Pagination */}
      {!isInitialLoading && listJobTemplates.length > 0 && (
        <div className="pagination">
          <button
            className={page <= 1 ? "bt disabled" : "bt"}
            onClick={() => handlePageChange(page - 1)}
            disabled={page <= 1}
          >
            &lt;&lt;
          </button>
          <span>
            {page} / {Math.ceil(listInfos.count / pageSize)}
          </span>
          <button
            className={
              page >= Math.ceil(listInfos.count / pageSize)
                ? "bt disabled"
                : "bt"
            }
            onClick={() => handlePageChange(page + 1)}
            disabled={page >= Math.ceil(listInfos.count / pageSize)}
          >
            &gt;&gt;
          </button>
        </div>
      )}
    </div>
  );
};

export default JobTemplates;
